import { render } from "./ContractorsGroup.vue?vue&type=template&id=0b3f21d8"
import script from "./ContractorsGroup.vue?vue&type=script&lang=js"
export * from "./ContractorsGroup.vue?vue&type=script&lang=js"

import "./ContractorsGroup.vue?vue&type=style&index=0&id=0b3f21d8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__